import { css } from "emotion";

export const classes = {
  infoText: css({ color: "#006096", fontFamily: "Roboto Condensed, sans-serif", fontSize: "1rem", lineHeight: "1rem" }),
  infoLocationText: css({
    color: "#FFFFFF", fontFamily: "Roboto Condensed, sans-serif",
    fontSize: "0.75rem", lineHeight: "1rem", textAlign: "justify"
  }),
};
